import { $, $$, isTablet, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y, FreeMode } from 'swiper/modules';
import dataLayerPushSlider from '@utils/dataLayerPushSlider';

function init() {
  if (!$('[data-au-featured-news]')) return;

  const slidersArray = [];

  addEventListeners(slidersArray);
  if (isTablet.matches) buildSlider(slidersArray);
}

function addEventListeners(slidersArray) {
  isTablet.addEventListener('change', () => einstuerzendeNeubauten(slidersArray));

  if ($('[data-au-featured-news-tab] [data-au-tab]')) {
    $$('[data-au-featured-news-tab] [data-au-tab]').forEach((tab) => {
      tab.addEventListener('click', () => einstuerzendeNeubauten(slidersArray));
    });
  }
}

function buildSlider(slidersArray) {
  $$('[data-au-featured-news]').forEach((slider) => {
    const newsSlider = new Swiper(slider, {
      modules: [Navigation, Scrollbar, A11y, FreeMode],
      ...sliderConfig,
      on: {
        touchEnd(swiper, event) {
          dataLayerPushSlider(swiper, event);
        },
      },
    });

    slidersArray.push(newsSlider);
  });
}

function einstuerzendeNeubauten(slidersArray) {
  slidersArray.forEach((slider) => slider.destroy());
  slidersArray.length = 0;

  if (isTablet.matches) {
    buildSlider(slidersArray);
  }
}

export default { init };
